/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CustomPlaceCrossing,
    CustomPlaceCrossingFromJSON,
    CustomPlaceCrossingFromJSONTyped,
    CustomPlaceCrossingToJSON,
    LibModelsActivityInterval,
    LibModelsActivityIntervalFromJSON,
    LibModelsActivityIntervalFromJSONTyped,
    LibModelsActivityIntervalToJSON,
    MuDataProcessingJoinersCustomPlaceCrossingManual,
    MuDataProcessingJoinersCustomPlaceCrossingManualFromJSON,
    MuDataProcessingJoinersCustomPlaceCrossingManualFromJSONTyped,
    MuDataProcessingJoinersCustomPlaceCrossingManualToJSON,
} from './';

/**
 * 
 * @export
 * @interface CustomPlaceCrossingWithCustomPlaceData
 */
export interface CustomPlaceCrossingWithCustomPlaceData {
    /**
     * 
     * @type {LibModelsActivityInterval}
     * @memberof CustomPlaceCrossingWithCustomPlaceData
     */
    activityInterval?: LibModelsActivityInterval;
    /**
     * 
     * @type {number}
     * @memberof CustomPlaceCrossingWithCustomPlaceData
     */
    driverId?: number;
    /**
     * 
     * @type {CustomPlaceCrossing}
     * @memberof CustomPlaceCrossingWithCustomPlaceData
     */
    customPlaceCrossing: CustomPlaceCrossing;
    /**
     * 
     * @type {MuDataProcessingJoinersCustomPlaceCrossingManual}
     * @memberof CustomPlaceCrossingWithCustomPlaceData
     */
    manual?: MuDataProcessingJoinersCustomPlaceCrossingManual;
    /**
     * 
     * @type {string}
     * @memberof CustomPlaceCrossingWithCustomPlaceData
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CustomPlaceCrossingWithCustomPlaceData
     */
    customPlaceName?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomPlaceCrossingWithCustomPlaceData
     */
    customPlaceAddress?: string;
}

export function CustomPlaceCrossingWithCustomPlaceDataFromJSON(json: any): CustomPlaceCrossingWithCustomPlaceData {
    return CustomPlaceCrossingWithCustomPlaceDataFromJSONTyped(json, false);
}

export function CustomPlaceCrossingWithCustomPlaceDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomPlaceCrossingWithCustomPlaceData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'activityInterval': !exists(json, 'activity_interval') ? undefined : LibModelsActivityIntervalFromJSON(json['activity_interval']),
        'driverId': !exists(json, 'driver_id') ? undefined : json['driver_id'],
        'customPlaceCrossing': CustomPlaceCrossingFromJSON(json['custom_place_crossing']),
        'manual': !exists(json, 'manual') ? undefined : MuDataProcessingJoinersCustomPlaceCrossingManualFromJSON(json['manual']),
        'id': json['id'],
        'customPlaceName': !exists(json, 'custom_place_name') ? undefined : json['custom_place_name'],
        'customPlaceAddress': !exists(json, 'custom_place_address') ? undefined : json['custom_place_address'],
    };
}

export function CustomPlaceCrossingWithCustomPlaceDataToJSON(value?: CustomPlaceCrossingWithCustomPlaceData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'activity_interval': LibModelsActivityIntervalToJSON(value.activityInterval),
        'driver_id': value.driverId,
        'custom_place_crossing': CustomPlaceCrossingToJSON(value.customPlaceCrossing),
        'manual': MuDataProcessingJoinersCustomPlaceCrossingManualToJSON(value.manual),
        'id': value.id,
        'custom_place_name': value.customPlaceName,
        'custom_place_address': value.customPlaceAddress,
    };
}


